import React, { useContext, useEffect, useMemo, useState } from "react";
import studylistContext from "../../../../../context/studylist/StudylistContext";
import AddTab from "../../../../Report/components/AddTab/AddTab";
import CustomEditor from "../../../../Report/components/CustomEditorSection/CustomEditor";
import AddTabVersion from "./AddTabVersion";
import ModalMain from "../../../../../components/Modal/ModalMain";
import ModalHeader from "../../../../../components/Modal/ModalHeader";
import NonEditableEditor from "./NonEditableEditor";

const ViewReportModal = () => {
    const {showVersionModalForReport,setShowVersionModalForReport} = useContext(studylistContext);
    const [activeTabIndex,setActiveTabIndex] = useState(0);


    const modalDetails = {
        header: (
          <ModalHeader
            heading="Report"
            updatedModal = {true}
            handleCancel={() => setShowVersionModalForReport({show:false,data:[]})}
          />
        ),
        body: <>
        <div className="report-container">
            <div style={{borderBottom:"1px solid #4D4D4D", display:'flex',flexDirection:'column'}}>
            <AddTabVersion data={showVersionModalForReport.data} setActiveTabIndex={setActiveTabIndex} activeTabIndex = {activeTabIndex}/>
            </div>
           <div style={{borderBottom:"1px solid #4D4D4D",paddingBottom:'5px'}}>
                  <NonEditableEditor customHeight={400} data={showVersionModalForReport.data} activeTabIndex = {activeTabIndex}/>
           </div>
           </div>
        </>,
        footer: (
          <></>
        ),
        width: "735px"
      };

      const style=  {
        root:{
          backgroundColor: 'unset'
       },
        main:{
          boxSizing: "border-box",
          borderRadius: "10px 0px 0px 0px",
          fontFamily: "Open Sans",
          fontStyle: "normal",
          boxShadow: 'none',
          width:'726px'
        },
      }

    return (<>
    <ModalMain
        modalDetails={modalDetails}
        showModal={true}
        updatedModal = {true}
        //styles={style}
      />
    </>)
};

export default ViewReportModal;